import { render } from "./ApplicationLogo.vue?vue&type=template&id=3deda1b4"
import script from "./ApplicationLogo.vue?vue&type=script&lang=js"
export * from "./ApplicationLogo.vue?vue&type=script&lang=js"
script.render = render

export default script